import { useEffect } from 'react';

import { useOnScreenKeyboardScrollFix } from './use-on-screen-keyboard-scroll-fix';
import { useViewportSize } from './use-viewport-size';

export const useSafariKeyboardPatches = () => {
    const initSize = window.innerHeight;
    const viewportSize = useViewportSize();
    const isSafari =
        navigator.userAgent.indexOf('Safari') > -1 &&
        navigator.userAgent.indexOf('Chrome') === -1;

    useEffect(() => {
        if (!isSafari) {
            return;
        }

        const bs = viewportSize?.[1] ? `${viewportSize[1] - 56}px` : 'auto';
        const button = document.querySelector('.ql-save-button') as HTMLElement;

        if (button) {
            button.style.top = bs;
        }

        const es = viewportSize?.[1]
            ? `${initSize - viewportSize[1] + 72}px`
            : '72px';
        const editor = document.querySelector('.ql-container') as HTMLElement;

        if (editor) {
            editor.style.bottom = es;
        }
    }, [viewportSize, isSafari, initSize]);

    useOnScreenKeyboardScrollFix(isSafari);
};
